import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Seo, { localBusinessSchema } from "../components/site/Seo";
import Breadcrumbs from "../components/site/Breadcrumbs";
import PageHero from "../components/site/PageHero";
import Reveal from "../components/site/Reveal";
import FinalCTA from "../components/site/FinalCTA";
import { PRIMARY_LOCATIONS, SECONDARY_LOCATIONS } from "../lib/locations";
import { IMG } from "../lib/site";

const ServiceAreasPage = () => (
  <div>
    <Seo
      title="Service Areas | Northern Arizona Floor Coatings | PRYME EPOXY"
      description="PRYME EPOXY serves Prescott, Flagstaff, Sedona and communities across Northern Arizona with premium garage and commercial floor coatings. Find your city."
      path="/service-areas"
      jsonLd={localBusinessSchema()}
    />
    <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Service Areas", path: "/service-areas" }]} />

    <PageHero
      overline="Service Areas"
      title="Proudly Serving All of Northern Arizona"
      subtitle="From our Prescott home base we travel across the region. Find your city below for local details, photos and reviews."
      image={IMG.roundRoom}
    />

    <section className="py-16 md:py-20 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <h2 className="text-2xl md:text-3xl font-light text-white mb-8">Primary Service Areas</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PRIMARY_LOCATIONS.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.06}>
              <Link to={`/service-areas/${c.slug}`} className="group block border border-zinc-800 bg-[#141414] overflow-hidden hover:border-[#C69453] transition-colors" data-testid={`city-card-${c.slug}`}>
                <div className="aspect-[16/10] overflow-hidden">
                  <img src={c.image} alt={`Floor coatings in ${c.name}, Arizona`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white flex items-center gap-2"><MapPin className="w-5 h-5 text-[#C69453]" />{c.name}, AZ</h3>
                  <p className="text-zinc-400 text-sm mt-2 line-clamp-3">{c.intro[0]}</p>
                  <span className="inline-flex items-center gap-2 mt-4 text-[#C69453] font-semibold group-hover:gap-3 transition-all">View {c.name} <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <h2 className="text-2xl md:text-3xl font-light text-white mt-16 mb-8">More Communities We Serve</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SECONDARY_LOCATIONS.map((c) => (
            <Link key={c.slug} to={`/service-areas/${c.slug}`} className="flex items-center justify-between border border-zinc-800 bg-[#141414] p-5 hover:border-[#C69453] transition-colors group" data-testid={`city-card-${c.slug}`}>
              <span className="text-white font-medium flex items-center gap-2"><MapPin className="w-4 h-4 text-[#C69453]" />{c.name}, AZ</span>
              <ArrowRight className="w-4 h-4 text-[#C69453] group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
    </section>

    <FinalCTA heading="Not Sure If We Cover Your Area? Just Ask." />
  </div>
);

export default ServiceAreasPage;
